import { AdvancedSearchConfig, attachmentPhotoAdvancedSearchGroup } from "../forms/advanced-search/advanced-search-fields-def";
import { ColumnFormatted } from "./general";

export const documentsColumns: ColumnFormatted[] = [
  { type: "string", key: "documentsDescriptionNumeroEnregistrement", visible: true },
  { type: "image", key: "vignette", visible: true },
  { type: "string", key: "documentsDescriptionTitre", visible: true },
  { type: "string", key: "documentsDescriptionLangueDOrigine" },
  {type: "string", key: "documentsDescriptionType", visible: true},
  {type: "string", key: "documentsDescriptionClassement", visible: true},
  {type: "string", key: "documentsDescriptionRangement"},
  {type: "string", key: "documentsDescriptionLocalisation", visible: true},
  {type: "string", key: "documentsDescriptionNombreExemplairesArchives"},
  {type: "string", key: "documentsDescriptionTheme"},
  {type: "string", key: "documentsDescriptionDate", visible: true},
  {type: "string", key: "documentsDescriptionTechnique"},
  {type: "string", key: "documentsDescriptionLieuDeCreation"},
  {type: "string", key: "documentsDescriptionPhotographe"},
  {type: "string", key: "documentsDescriptionCopyright"},
  {type: "boolean", key: "documentsDescriptionCopies"},
  {type: "string", key: "documentsDescriptionNombreFeuillets"},
  {type: "string", key: "documentsDescriptionPhotoAutresPages"},
  {type: "richtext", key: "documentsDescriptionLegendePhotoAutresPages"},
  {type: "richtext", key: "documentsDescriptionLegendeRedigee"},
  {type: "richtext", key: "documentsDescriptionNotes"},
  {type: "richtext", key: "documentsDescriptionRetranscription"},
  {type: "boolean", key: "documentsFichierPhotoBasseDefinitionUniquement"},
  {type: "boolean", key: "documentsFichierPhotoScanAFaire"},
  {type: "boolean", key: "documentsFichierPhotoOkWeb"},
  {type: "boolean", key: "documentsFichierPhotoHdOk"},
  {type: "boolean", key: "documentsValidationPublicationNumerisee"},
  {type: "boolean", key: "documentsValidationPdfEtOcrOk"},
  {type: "boolean", key: "documentsAcquisitionDocumentAAcquerir"},
  {type: "boolean", key: "documentsAcquisitionDocumentAcquis"},
  {type: "string", key: "documentsAcquisitionDateAcquisition"},
  {type: "string", key: "documentsAcquisitionVendeur"},
  {type: "richtext", key: "documentsAcquisitionNotes"},
  {type: "string", key: "documentsMouvementsDepot"},
  {type: "richtext", key: "documentsMouvementsNotesDepot"},
  {type: "currency", key: "documentsMouvementsValeurAssurance"},
  {type: "richtext", key: "sources"},
  {type: "status", key: "documentsPublicationStatus", visible: true},
];

export const documentsColumnsVisibility = documentsColumns.reduce(
  (acc, column) => ({
    ...acc,
    [column.key]: column.visible ?? true,
  }),
  {} as Record<string, boolean>,
);

export const documentsAdvancedSearchConfig: AdvancedSearchConfig = [
  {
    type: "group",
    label: "documentsDescription",
    fields: [
      { type: "string", key: "documentsDescriptionNumeroEnregistrement" },
      { type: "boolean", key: "documentsDescriptionCopies" },
      { type: "string", key: "documentsDescriptionType" },
      { type: "string", key: "documentsDescriptionClassement" },
      { type: "string", key: "documentsDescriptionRangement" },
      { type: "string", key: "documentsDescriptionLocalisation" },
      { type: "string", key: "documentsDescriptionNombreExemplairesArchives" },
      { type: "string", key: "documentsDescriptionTitre" },
      { type: "string", key: "documentsDescriptionLangueDOrigine" },
      { type: "string", key: "documentsDescriptionDate" },
      { type: "string", key: "documentsDescriptionTheme" },
      { type: "string", key: "documentsDescriptionDimensions" },
      { type: "string", key: "documentsDescriptionTechnique" },
      { type: "string", key: "documentsDescriptionLieuDeCreation" },
      { type: "string", key: "documentsDescriptionPhotographe" },
      { type: "string", key: "documentsDescriptionCopyright" },
      { type: "string", key: "documentsDescriptionNombreFeuillets" },
      { type: "string", key: "documentsDescriptionLegendeRedigee" },
      { type: "string", key: "documentsDescriptionNotes" },
      {
        type: "boolean",
        key: "documentsFichierPhotoBasseDefinitionUniquement",
      },
      { type: "boolean", key: "documentsFichierPhotoScanAFaire" },
      { type: "boolean", key: "documentsFichierPhotoOkWeb" },
      { type: "boolean", key: "documentsFichierPhotoHdOk" },
      { type: "boolean", key: "documentsValidationPublicationNumerisee" },
      { type: "boolean", key: "documentsValidationPdfEtOcrOk" },
      { type: "boolean", key: "documentsAcquisitionDocumentAAcquerir" },
      { type: "boolean", key: "documentsAcquisitionDocumentAcquis" },
      { type: "string", key: "documentsAcquisitionDateAcquisition" },
      { type: "string", key: "documentsAcquisitionVendeur" },
      { type: "string", key: "documentsAcquisitionNotes" },
      { type: "string", key: "documentsMouvementsDepot" },
      { type: "string", key: "documentsMouvementsNotesDepot" },
      { type: "string", key: "documentsMouvementsValeurAssurance" },
      { type: "string", key: "documentsDescriptionRetranscription" },
    ],
  },
  {
    type: "group",
    label: "sources",
    fields: [{ type: "string", key: "sources" }],
  },
  attachmentPhotoAdvancedSearchGroup,
];
